import React from 'react';
import TimeSeriesChart, { CHART_COLORS } from './TimeSeriesChart';
import { formatPercent } from './format';
import { percentSeries } from './series';
import type { Sample } from './types';

interface PanelProps {
  samples: Sample[];
  timestamps: number[];
  sampleCounts: number[];
}

export default function CpuPanel({ samples, timestamps, sampleCounts }: PanelProps) {
  const series = percentSeries(samples, (snapshot) => snapshot.cpu_usage, {
    id: 'cpu',
    label: 'CPU',
    color: CHART_COLORS.primary,
  });

  return (
    <TimeSeriesChart
      title="CPU usage"
      timestamps={timestamps}
      sampleCounts={sampleCounts}
      series={[series]}
      // Fixed rather than auto-scaled: on a percentage axis, an idle machine
      // auto-scaled to its own noise looks exactly like a busy one.
      yMax={100}
      formatValue={formatPercent}
    />
  );
}
